import { computed, toValue } from 'vue';
import { buildHitgroupData, regionDelta } from '../utils/hitgroups';
import { useStatDefinitions } from './useStatBreakdown';

// Shared model of the hitgroup panel (classic HitgroupPanel and the v5 match page).
// `values` is the selected player's stat map from the match payload (ref or getter).
export default function useHitgroups(values) {
  const definitions = useStatDefinitions();
  const data = computed(() => buildHitgroupData(toValue(values), definitions.value));

  // Regions that scored, biggest contribution to the efficiency first.
  const points = (region) => region.hitCount * data.value.multipliers[region.key];
  const scoredRegions = computed(() => (data.value?.regions ?? [])
    .filter((region) => region.hitCount > 0)
    .sort((a, b) => points(b) - points(a)));

  // Efficiency points vs the bracket; under 2 points reads as level.
  const effDelta = computed(() => {
    if (data.value?.efficiency == null || data.value?.peerEfficiency == null) return null;
    const diff = data.value.efficiency - data.value.peerEfficiency;
    if (Math.abs(diff) < 2) return { diff, tone: 'flat' };
    return { diff, tone: diff > 0 ? 'good' : 'bad' };
  });

  // Every region against the bracket, in body order; empty without peer data.
  const breakdownRows = computed(() => (data.value?.regions ?? [])
    .map((region) => ({ region, ...(regionDelta(region) ?? {}) }))
    .filter((gap) => gap.tone != null));

  return {
    data, scoredRegions, effDelta, breakdownRows,
  };
}
